import React, { useState } from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { toHtml } from '~/utils'
import styled from 'styled-components'

const StyledDownUp = styled.div`
  word-break: break-all;
`

export const DownUp: React.FC<{
  text: string
  limit: number
  lineNumber?: number
  style?: React.CSSProperties
  className?: string
}> = ({ text, limit, lineNumber = 2, style, className }) => {
  const [showFullText, setShowFullText] = useState(false)

  return (
    <StyledDownUp className={className} style={style}>
      {showFullText ? (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: toHtml(text),
            }}
          ></div>
          <UpOutlined onClick={() => setShowFullText(false)} />
        </>
      ) : (
        <>
          {text.length >= limit ? (
            <>
              <div
                className={`line-clamp-${lineNumber}`}
                dangerouslySetInnerHTML={{
                  __html: toHtml(text),
                }}
              ></div>

              <DownOutlined onClick={() => setShowFullText(true)} />
            </>
          ) : (
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: toHtml(text),
                }}
              ></div>
            </>
          )}
        </>
      )}
    </StyledDownUp>
  )
}
